export default "__VITE_ASSET__xugJhXdh__"